module.exports = __webpack_public_path__ + "img/银耳.70e26917.jpg";